import React, { useCallback, useState } from 'react';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import Toggle from '@r1-frontend/ui-react/components/controls/Toggle';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { ACTIONS, CATEGORIES, EVENTS } from '@r1-frontend/shared/constants/analytics';

import { videocontrolAdvantagesTabs, videocontrolInsideData, videocontrolOutsideData } from '~/src/features/videocontrol/data';
import AdvantagesBlock from '~/src/features/videocontrol/pageBlocks/Advantages/AdvantagesBlock';

import * as ST from './styled';

const Advantages: React.FC = () => {

    const [activeTabToggle, setActiveTabToggle] = useState(videocontrolAdvantagesTabs.leftText);

    const onSwitchTab = useCallback((label: string) => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: CATEGORIES.landing,
            action: ACTIONS.clickOnBtn,
            label: label === videocontrolAdvantagesTabs.leftText ? 'inside' : 'outside',
        });
        setActiveTabToggle(label);
    }, []);

    return (
        <ST.AdvantagesContainer>
            <Toggle
                onChangeCallback={onSwitchTab}
                activeTab={activeTabToggle}
                colorTab={COLORS.Logo}
                textsValues={videocontrolAdvantagesTabs}
                isDifferentColorText={false}
            />
            {activeTabToggle === videocontrolAdvantagesTabs.leftText
                ? <AdvantagesBlock incomingData={videocontrolInsideData}/>
                : <AdvantagesBlock incomingData={videocontrolOutsideData}/>}
        </ST.AdvantagesContainer>
    );
};

export default Advantages;
